import React, { useEffect, useRef, useState } from 'react';
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import './selectDateRange.css';
import moment from 'moment';
import { toast } from 'react-toastify';

/*
 * Trips: pick a start date, the end date is start + packData.days.
 * Stays (freeRange): pick check-in and check-out yourself
 *   <SelectDateRange freeRange minimumNights={1} ... />
 */
const SelectDateRange = ({
    startDate,
    endDate,
    confirmedBookingData,
    packData,
    setDates,
    daysToAdd,
    freeRange = false,
    minimumNights = 1,
    startPlaceholder,
    endPlaceholder
}) => {
    const [focused, setFocused] = useState(null);
    const notAllowedDates = useRef([]);
    const unavailable = packData?.unavailableDates || [];
    const blockedDates = unavailable.map((d) => moment(d));

    useEffect(() => {
        // The notAllowedDates should be updated only when dates are of upcoming data
        if (true) {
            notAllowedDates.current = unavailable.map((da) => {
                return moment(da);
            });
        }
        //eslint-disable-next-line
    }, [packData?.unavailableDates]);

    const isDayBlocked = (day) => {
        return notAllowedDates.current.some((notAllowedDate) => notAllowedDate.isSame(day, 'day'));
    };

    return (
        <div className='dateRangePicker-container'>
            <DateRangePicker
                startDate={startDate}
                startDateId='startDate'
                endDate={endDate}
                endDateId='endDate'
                onDatesChange={({ startDate, endDate }) => {
                    const daysToAdd = packData?.days;
                    const updatedEndDate = freeRange
                        ? endDate
                        : startDate
                          ? moment(startDate).add(daysToAdd, 'days')
                          : endDate;
                    const isBlocked =
                        startDate &&
                        updatedEndDate &&
                        blockedDates.some((date) => date.isBetween(startDate, updatedEndDate, 'day', '[]'));
                    if (isBlocked) {
                        toast.warn(freeRange ? 'Your stay cannot include unavailable dates' : 'Trip cannot include blocked dates');
                        setDates(null, null);
                        setTimeout(() => setFocused('startDate'), 10);
                        return;
                    }
                    setDates(startDate, updatedEndDate);
                    if (startDate && updatedEndDate) {
                        setTimeout(() => setFocused(null), 10);
                    }
                }}
                disabled={confirmedBookingData?.startDate && confirmedBookingData?.isTripMoreThanOneDays}
                focusedInput={focused}
                onFocusChange={(focusedInput) => setFocused(focusedInput)}
                numberOfMonths={1}
                minimumNights={minimumNights}
                startDatePlaceholderText={startPlaceholder || 'Start Date'}
                endDatePlaceholderText={endPlaceholder || 'End Date'}
                showClearDates={true}
                displayFormat='DD/MM/YYYY'
                isDayBlocked={isDayBlocked}
            />
        </div>
    );
};

export default SelectDateRange;
